import { t } from '@avalara/bat-apps-shared/i18n';
import { Fragment } from 'react';

import ExternalLink from '../../external-link';

type TermsLink = { text: string; url: string };

type Props = {
  termsChecked: boolean;
  onTermsChange: (checked: boolean) => void;
  separateAgreementChecked: boolean;
  onSeparateAgreementChange: (checked: boolean) => void;
  links: Array<TermsLink>;
};

// Skylab styles checkboxes via `input[type=checkbox]+label`, using ::before/::after on the LABEL
// (not the input) as the visible box — so the input and label must be true DOM siblings, not
// nested. Skylab's own stylesheet never sets `position: relative` on that label, so the label
// needs it here for its absolutely-positioned ::before/::after to anchor to itself rather than
// some other ancestor.
const TermsAndConditions = ({
  termsChecked,
  onTermsChange,
  separateAgreementChecked,
  onSeparateAgreementChange,
  links,
}: Props) => (
  <div data-ref='buy.order-review.terms' className='pad-bottom-md pad-top-md'>
    <h2 data-ref='buy.order-review.terms.heading'>{t('client.order-review.terms.heading')}</h2>
    <div>
      <input
        type='checkbox'
        id='order-review-terms-checkbox'
        data-ref='buy.order-review.terms.checkbox'
        checked={termsChecked}
        onChange={(e) => onTermsChange(e.target.checked)}
      />
      <label htmlFor='order-review-terms-checkbox' style={{ position: 'relative' }}>
        {t('client.order-review.terms.agree-to')}{' '}
        {links.map((link, i) => (
          <Fragment key={link.url}>
            {i > 0 && ' and '}
            <ExternalLink
              href={link.url}
              alwaysOpenInNewTab
              className='button link margin-left-none'
              color='var(--color-accent-text)'
            >
              {link.text}
            </ExternalLink>
          </Fragment>
        ))}
      </label>
    </div>

    <div>
      <input
        type='checkbox'
        id='order-review-separate-agreement-checkbox'
        data-ref='buy.order-review.terms.separate-agreement-checkbox'
        checked={separateAgreementChecked}
        onChange={(e) => onSeparateAgreementChange(e.target.checked)}
      />
      <label htmlFor='order-review-separate-agreement-checkbox' style={{ position: 'relative' }}>
        {t('client.order-review.terms.separate-agreement-acknowledgement')}
      </label>
    </div>
  </div>
);

export default TermsAndConditions;
